import {
  useMutation,
  UseMutationResult,
  UseMutationOptions,
} from "@tanstack/react-query"
import { guardAppUsage } from "@mimber-client/guards/AppGuard"
import { useServerContext } from "@mimber-client/contexts/ServerContext"
import type { ResponseDto, StepUpInitiateResponseDto } from "@mimber/schema"

export const useInitiateStepUp = (
  options?: UseMutationOptions<
    ResponseDto<StepUpInitiateResponseDto>,
    Error,
    void
  >
): UseMutationResult<ResponseDto<StepUpInitiateResponseDto>, Error, void> => {
  guardAppUsage("mimber-organization", "useInitiateStepUp")

  const { server } = useServerContext()

  return useMutation({
    ...options,
    mutationFn: async () => {
      const response = await server.post<
        ResponseDto<StepUpInitiateResponseDto>
      >("account/mfa/step-up/initiate")
      return response.data
    },
  })
}
